{
  "actionButtons": {
    "deselectAll": "deselectAll",
    "export": "export",
    "exportAsCsv": "exportAsCsv",
    "exportAsPdf": "exportAsPdf",
    "selectAll": "selectAll"
  },
  "areYouSureModal": {
    "cancelText": "cancelText",
    "confirmText": "confirmText",
    "title": "title"
  },
  "columnManager": {
    "columns": "columns",
    "hiddenColumns": "hiddenColumns",
    "noColumnsMatch": "noColumnsMatch",
    "pinnedColumns": "pinnedColumns",
    "searchPlaceholder": "searchPlaceholder",
    "visibleColumns": "visibleColumns"
  },
  "coordinates": {
    "latitude": "latitude",
    "latitudePlaceholder": "latitudePlaceholder",
    "latitudeTooltip": "latitudeTooltip",
    "longitude": "longitude",
    "longitudePlaceholder": "longitudePlaceholder",
    "longitudeTooltip": "longitudeTooltip"
  },
  "copy": "{{text}} panoya kopyalandı",
  "countries": {
    "AC": "Yükseliş Adası",
    "AD": "Andorra",
    "AE": "Birleşik Arap Emirlikleri",
    "AF": "Afganistan",
    "AG": "Antigua ve Barbuda",
    "AI": "Anguilla",
    "AL": "Arnavutluk",
    "AM": "Ermenistan",
    "AO": "Angola",
    "AQ": "Antarktika",
    "AR": "Arjantin",
    "AS": "Amerikan Samoası",
    "AT": "Avusturya",
    "AU": "Avustralya",
    "AW": "Aruba",
    "AX": "Åland Adaları",
    "AZ": "Azerbaycan",
    "BA": "Bosna-Hersek",
    "BB": "Barbados",
    "BD": "Bangladeş",
    "BE": "Belçika",
    "BF": "Burkina Faso",
    "BG": "Bulgaristan",
    "BH": "Bahreyn",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivya",
    "BQ": "Karayip Hollanda",
    "BR": "Brezilya",
    "BS": "Bahamalar",
    "BT": "Bhutan",
    "BV": "Bouvet Adası",
    "BW": "Botsvana",
    "BY": "Beyaz Rusya",
    "BZ": "Belize",
    "CA": "Kanada",
    "CC": "Cocos Adaları (Keeling)",
    "CD": "Kongo-Kinşasa",
    "CF": "Orta Afrika Cumhuriyeti",
    "CG": "Kongo-Brazavil",
    "CH": "İsviçre",
    "CI": "Fildişi Sahili",
    "CK": "Cook Adaları",
    "CL": "Şili",
    "CM": "Kamerun",
    "CN": "Çin",
    "CO": "Kolombiya",
    "CP": "Clipperton Adası",
    "CR": "Kosta Rika",
    "CU": "Küba",
    "CV": "Yeşil Burun Adaları",
    "CW": "Curaçao",
    "CX": "Christmas Adası",
    "CY": "Kıbrıs",
    "CZ": "Çek Cumhuriyeti",
    "DE": "Almanya",
    "DG": "Diego Garcia",
    "DJ": "Cibuti",
    "DK": "Danimarka",
    "DM": "Dominika",
    "DO": "Dominik Cumhuriyeti",
    "DZ": "Cezayir",
    "EA": "Ceuta ve Melilla",
    "EC": "Ekvador",
    "EE": "Estonya",
    "EG": "Mısır",
    "EH": "Batı Sahra",
    "ER": "Eritre",
    "ES": "İspanya",
    "ET": "Etiyopya",
    "EU": "Avrupa Birliği",
    "FI": "Finlandiya",
    "FJ": "Fiji",
    "FK": "Falkland Adaları",
    "FM": "Mikronezya",
    "FO": "Faroe Adaları",
    "FR": "Fransa",
    "GA": "Gabon",
    "GB": "Birleşik Krallık",
    "GD": "Grenada",
    "GE": "Gürcistan",
    "GF": "Fransız Guyanası",
    "GG": "Guernsey",
    "GH": "Gana",
    "GI": "Cebelitarık",
    "GL": "Grönland",
    "GM": "Gambiya",
    "GN": "Gine",
    "GP": "Guadeloupe",
    "GQ": "Ekvator Ginesi",
    "GR": "Yunanistan",
    "GS": "Güney Georgia ve Güney Sandwich Adaları",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Gine-Bissau",
    "GY": "Guyana",
    "HK": "Çin Hong Kong ÖİB",
    "HM": "Heard Adası ve McDonald Adaları",
    "HN": "Honduras",
    "HR": "Hırvatistan",
    "HT": "Haiti",
    "HU": "Macaristan",
    "IC": "Kanarya Adaları",
    "ID": "Endonezya",
    "IE": "İrlanda",
    "IL": "İsrail",
    "IM": "Man Adası",
    "IN": "Hindistan",
    "IO": "Britanya Hint Okyanusu Toprakları",
    "IQ": "Irak",
    "IR": "İran",
    "IS": "İzlanda",
    "IT": "İtalya",
    "JE": "Jersey",
    "JM": "Jamaika",
    "JO": "Ürdün",
    "JP": "Japonya",
    "KE": "Kenya",
    "KG": "Kırgızistan",
    "KH": "Kamboçya",
    "KI": "Kiribati",
    "KM": "Komorlar",
    "KN": "Saint Kitts ve Nevis",
    "KP": "Kuzey Kore",
    "KR": "Güney Kore",
    "KW": "Kuveyt",
    "KY": "Cayman Adaları",
    "KZ": "Kazakistan",
    "LA": "Laos",
    "LB": "Lübnan",
    "LC": "Saint Lucia",
    "LI": "Lihtenştayn",
    "LK": "Sri Lanka",
    "LR": "Liberya",
    "LS": "Lesotho",
    "LT": "Litvanya",
    "LU": "Lüksemburg",
    "LV": "Letonya",
    "LY": "Libya",
    "MA": "Fas",
    "MC": "Monako",
    "MD": "Moldova",
    "ME": "Karadağ",
    "MF": "Saint Martin",
    "MG": "Madagaskar",
    "MH": "Marshall Adaları",
    "MK": "Kuzey Makedonya",
    "ML": "Mali",
    "MM": "Myanmar (Burma)",
    "MN": "Moğolistan",
    "MO": "Çin Makao ÖİB",
    "MP": "Kuzey Mariana Adaları",
    "MQ": "Martinik",
    "MR": "Moritanya",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldivler",
    "MW": "Malavi",
    "MX": "Meksika",
    "MY": "Malezya",
    "MZ": "Mozambik",
    "NA": "Namibya",
    "NC": "Yeni Kaledonya",
    "NE": "Nijer",
    "NF": "Norfolk Adası",
    "NG": "Nijerya",
    "NI": "Nikaragua",
    "NL": "Hollanda",
    "NO": "Norveç",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Yeni Zelanda",
    "OM": "Umman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "Fransız Polinezyası",
    "PG": "Papua Yeni Gine",
    "PH": "Filipinler",
    "PK": "Pakistan",
    "PL": "Polonya",
    "PM": "Saint Pierre ve Miquelon",
    "PN": "Pitcairn Adaları",
    "PR": "Porto Riko",
    "PS": "Filistin Bölgesi",
    "PT": "Portekiz",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Katar",
    "RE": "Réunion",
    "RO": "Romanya",
    "RS": "Sırbistan",
    "RU": "Rusya",
    "RW": "Ruanda",
    "SA": "Suudi Arabistan",
    "SB": "Solomon Adaları",
    "SC": "Seyşeller",
    "SD": "Sudan",
    "SE": "İsveç",
    "SG": "Singapur",
    "SH": "Saint Helena",
    "SI": "Slovenya",
    "SJ": "Svalbard ve Jan Mayen",
    "SK": "Slovakya",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somali",
    "SR": "Surinam",
    "SS": "Güney Sudan",
    "ST": "Sao Tome ve Principe",
    "SV": "El Salvador",
    "SX": "Sint Maarten (Hollanda Bölümü)",
    "SY": "Suriye",
    "SZ": "Esvatini",
    "TA": "Tristan da Cunha",
    "TC": "Turks ve Caicos Adaları",
    "TD": "Çad",
    "TF": "Fransız Güney Toprakları",
    "TG": "Togo",
    "TH": "Tayland",
    "TJ": "Tacikistan",
    "TK": "Tokelau",
    "TL": "Doğu Timor",
    "TM": "Türkmenistan",
    "TN": "Tunus",
    "TO": "Tonga",
    "TR": "Türkiye",
    "TT": "Trinidad ve Tobago",
    "TV": "Tuvalu",
    "TW": "Tayvan",
    "TZ": "Tanzanya",
    "UA": "Ukrayna",
    "UG": "Uganda",
    "UM": "ABD Küçük Dış Adaları",
    "UN": "Bilinmeyen",
    "US": "Amerika Birleşik Devletleri",
    "UY": "Uruguay",
    "UZ": "Özbekistan",
    "VA": "Vatikan Şehri",
    "VC": "Saint Vincent ve Grenadinler",
    "VE": "Venezuela",
    "VG": "Britanya Virjin Adaları",
    "VI": "ABD Virjin Adaları",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis ve Futuna",
    "WS": "Samoa",
    "XK": "Kosova",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "Güney Afrika",
    "ZM": "Zambiya",
    "ZW": "Zimbabve"
  },
  "countriesEcobalyse": {
    "BD": "BD",
    "CN": "CN",
    "FR": "FR",
    "IN": "IN",
    "KH": "KH",
    "MA": "MA",
    "MM": "MM",
    "PK": "PK",
    "RAF": "RAF",
    "RAS": "RAS",
    "REE": "REE",
    "REO": "REO",
    "RLA": "RLA",
    "RME": "RME",
    "RNA": "RNA",
    "ROC": "ROC",
    "TN": "TN",
    "TR": "TR",
    "VN": "VN"
  },
  "dataLoad": {
    "error": {
      "message": "Verileri alamadık. Lütfen sayfayı yeniden yükleyin.",
      "title": "Bir hata oluştu"
    },
    "noResults": {
      "message": "Şirketinizle ilgili herhangi bir veri bulunamadı. Lütfen daha sonra tekrar deneyin.",
      "title": "Sonuç bulunamadı"
    }
  },
  "documentUpload": {
    "helptext": "Maksimum boyut: {{ maxSize }}MB",
    "missingDocument": "missingDocument",
    "title": "Dosyalarınızı buraya sürükleyin veya manuel olarak seçmek için tıklayın",
    "uploadSuppliers": "uploadSuppliers"
  },
  "error": {
    "default": "Bir hata oluştu",
    "message": "message",
    "title": "title"
  },
  "fabricProcess": {
    "knitting-circular": "knitting-circular",
    "knitting-fully-fashioned": "knitting-fully-fashioned",
    "knitting-integral": "knitting-integral",
    "knitting-mix": "knitting-mix",
    "knitting-straight": "knitting-straight",
    "weaving": "weaving"
  },
  "filter": "filter",
  "form": {
    "reset": "reset",
    "save": "save"
  },
  "languages": {
    "arabic": "Arapça",
    "belarusian": "Belarusça",
    "chinese": "Çince",
    "dutch": "Hollandaca",
    "english": "İngilizce",
    "french": "Fransızca",
    "german": "Almanca",
    "italian": "İtalyanca",
    "japanese": "Japonca",
    "korean": "Korece",
    "lithuanian": "Litvanca",
    "portuguese": "Portekizce",
    "romanian": "Rumence",
    "spanish": "İspanyolca",
    "turkish": "Türkçe"
  },
  "lists": {
    "noData": {
      "title": "Veri bulunamadı"
    }
  },
  "menus": {
    "admin": "Yönetici",
    "businessPartners": "İş Ortakları",
    "certificates": "Sertifikalar",
    "communicationStudio": "Studio",
    "dashboard": "Kontrol Paneli",
    "dataTransfer": "Veri Transferi",
    "faq": "SSS",
    "invoices": "invoices",
    "logout": "Çıkış Yap",
    "products": "Ürünler",
    "profile": "profile",
    "regulations": "regulations"
  },
  "showOnlyMainFabric": "showOnlyMainFabric",
  "simulation": {
    "notSubscribed": {
      "message": "Bu simülatöre abone değilsiniz",
      "title": "Bu simülatöre abone değilsiniz"
    }
  },
  "sort": {
    "ascending": "Artan",
    "descending": "Azalan",
    "search": {
      "placeholder": "Sıralamak için arama yapın"
    },
    "title": "Sıralama"
  },
  "success": {
    "message": "işlem başarılı",
    "title": "başarılı"
  },
  "supplier": {
    "footer": {
      "privacyPolicy": "Gizlilik Politikası"
    },
    "menu": {
      "contacts": "İletişim",
      "documentation": "SSS ve Kullanıcı Rehberi",
      "loggedAs": "Olarak giriş yaptınız",
      "productionSites": "Üretim Siteleri",
      "requests": "Müşteri Talepleri",
      "supplierRequests": "Tedarikçi Takibi"
    }
  },
  "table": {
    "filter": {
      "date": {
        "preset": {
          "custom": "Özel",
          "oneMonthAgo": "Bir ay önce",
          "oneMonthFromNow": "Bir ay sonra",
          "oneWeekAgo": "oneWeekAgo",
          "oneWeekFromNow": "Bir hafta sonra",
          "oneYearAgo": "oneYearAgo",
          "oneYearFromNow": "Bir yıl sonra",
          "today": "today",
          "tomorrow": "Yarın",
          "yesterday": "Dün"
        }
      },
      "operator": {
        "after": "Sonra",
        "afterOrEquals": "Sonra veya eşit",
        "before": "Önce",
        "beforeOrEquals": "Önce veya eşit",
        "between": "Arasında",
        "empty": "Boş",
        "equals": "Eşit",
        "isEmpty": "Boş",
        "isNotEmpty": "Boş değil",
        "notBetween": "Arasında değil",
        "notEmpty": "Boş değil",
        "notEquals": "Eşit değil"
      }
    },
    "hideColumn": "Gizle",
    "manageColumns": "Sütunları yönet",
    "noDataMessage": "Veri bulunamadı",
    "noDataTitle": "Veri bulunamadı",
    "pinColumn": "Sabitle",
    "rowsPerPage": "Satır başına sayfa",
    "showColumn": "Göster",
    "total": "Toplam: ",
    "unpinColumn": "Sabitlemeyi kaldır",
    "views": {
      "add": {
        "error": {
          "message": "Görünüm oluşturulamadı",
          "title": "Görünüm oluşturulamadı"
        },
        "success": {
          "message": "Görünüm oluşturuldu",
          "title": "Görünüm oluşturuldu"
        }
      },
      "delete": {
        "error": {
          "message": "Görünüm silinemedi",
          "title": "Görünüm silinemedi"
        },
        "modal": {
          "cancel": "İptal",
          "delete": "Sil",
          "description": "Görünümü {{viewName}} silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
          "title": "Onay"
        },
        "success": {
          "message": "Görünüm silindi",
          "title": "Görünüm silindi"
        }
      },
      "modal": {
        "description": "Görünüm oluşturmak için lütfen aşağıdaki bilgileri giriniz.",
        "pinnedToDashboard": {
          "label": "Sütunları sabitle",
          "tooltip": "Sütunları dashboard'a sabitleyin"
        },
        "reset": "Sıfırla",
        "save": "Kaydet (beta)",
        "title": "Görünüm oluştur (beta)",
        "update": "Güncelle"
      },
      "update": {
        "error": {
          "message": "Görünüm güncellenemedi",
          "title": "Görünüm güncellenemedi"
        },
        "success": {
          "message": "Görünüm güncellendi",
          "title": "Görünüm güncellendi"
        }
      },
      "viewName": "Görünüm adı",
      "viewNamePlaceholder": "Görünüm adı girin"
    }
  },
  "zodErrors": {
    "errorDefault": "Geçersiz değer",
    "invalidEmail": "Geçersiz e-posta adresi",
    "latitudeOutOfRange": "Enlem değeri geçersiz",
    "longitudeOutOfRange": "Boylam değeri geçersiz",
    "mustContainBothLatitudeAndLongitude": "Enlem ve boylam değerleri gereklidir",
    "noSpecialCharacters": "Değer en az 2 karakterden oluşmalı ve özel karakter içermemelidir",
    "ValueTooLong": "Değer çok uzun",
    "ValueTooShort": "Değer çok kısa"
  }
}
